import React from "react";
import "./FloatingButton.style.css";
import useQuestion from "../../hooks/useQuestion";

const FloatingButton: React.FC = () => {
  const { count } = useQuestion();

  return (
    <button disabled className="floating-button">
      {count}
    </button>
  );
};

export default FloatingButton;
